/**
 * A global namespace for `touchstart` event.
 */
const touchstartEvent = 'touchstart';
export default touchstartEvent;
